module.exports = __webpack_public_path__ + "img/bigo-ads-app.9e26db37.svg";